const c = window;
c.o_global ||= {}, c.o_util ||= {};
const M = c.otto ?? {}, e = M.tracking, k = e.submitEvent, l = e.submitEventMerge, C = e.submitMerge, f = e.submitMove, v = e.submitMiniAction;
e.createEventMergeContext;
const d = e.trackOnNextPageImpression;
e.createContext;
e.replaceContext;
e.closeContext;
e.getPageMergeId;
e.createPage;
e.trackBlockedFeatures;
const g = window;
g.o_global ||= {}, g.o_util ||= {};
const { o_global: p } = g, w = /*                      */ (n, r, i) => n[r] ?? i, E = (() => {
}), x = /*           */ w(p, "debug", {}), A = /*           */ w(x, "logger", E), s = A("ft-nav.star-track"), I = (n) => n;
function N(n) {
  return n !== n.toLowerCase();
}
function O(n) {
  return Array.from(n).flatMap((r, i) => N(r) ? i !== 0 ? ["-", r.toLowerCase()] : r.toLowerCase() : r).join("");
}
const P = (n) => {
  const r = n.dataset;
  return r ? Object.keys(r).filter(
    (a) => a.startsWith("navTracking")
  ).reduce((a, o) => {
    const u = `user-action/${O(o.substring(11))}`, b = JSON.parse(r[o]);
    return a[u] = b, a;
  }, {}) : void 0;
}, h = (n, r, i = I) => {
  const a = n.closest(
    '[data-nav-track="true"]'
  );
  if (!a) return;
  const o = P(a);
  if (!o) return;
  const u = o[r];
  u && i(u).forEach((t) => {
    switch (t.method) {
      case "submitEvent":
        s.debug(
          "window.otto.tracking.submitEvent",
          t.dataContainer,
          t.action
        ), t.action ? k(t.dataContainer, t.action) : k(t.dataContainer);
        break;
      case "submitEventMerge":
        s.debug(
          "window.otto.tracking.submitEventMerge",
          t.eventMergeId,
          t.dataContainer,
          t.action
        ), t.action ? l(
          t.eventMergeId,
          t.dataContainer,
          t.action
        ) : l(t.eventMergeId, t.dataContainer);
        break;
      case "submitMerge":
        s.debug(
          "window.otto.tracking.submitMerge",
          t.dataContainer,
          t.features
        ), t.features ? C(t.dataContainer, t.features) : C(t.dataContainer);
        break;
      case "submitMove":
        s.debug(
          "window.otto.tracking.submitMove",
          t.dataContainer,
          t.action
        ), t.action ? f(t.dataContainer, t.action) : f(t.dataContainer);
        break;
      case "submitMiniAction":
        s.debug("window.otto.tracking.submitMiniAction", t.updates), v(t.updates);
        break;
      case "trackOnNextPageImpression":
        s.debug(
          "window.otto.tracking.trackOnNextPageImpression",
          t.dataContainer
        ), d(t.dataContainer);
        break;
    }
  });
};
export {
  h as track
};
